(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/new-customer/new-customer.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/new-customer/new-customer.js');
'use strict';

const _svs$accountservicesR = svs.accountservicesReact.deposit.swedbankExpress.sharedComponents,
  NewCustomerInfo = _svs$accountservicesR.NewCustomerInfo,
  ConsentInfo = _svs$accountservicesR.ConsentInfo;
const Button = svs.ui.ReactButton;
const ReactInfoButtonText = svs.tb_ui.ReactInfoButtonText;
const showExpressMoreInformationAsync = svs.accountservicesReact.deposit.dialogs.swedbankExpressDialogs.showExpressMoreInformationAsync;
const NewCustomer = _ref => {
  let onClick = _ref.onClick;
  const handleGetBankAccount = () => {
    onClick();
  };
  const handleShowMoreInfo = () => {
    showExpressMoreInformationAsync();
  };
  return React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(NewCustomerInfo, null), React.createElement(ReactInfoButtonText, {
    onClick: handleShowMoreInfo,
    text: "L\xE4s mer om Expressbetalning"
  }), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    focus: true,
    onClick: handleGetBankAccount
  }, "H\xE4mta bankkonton"), React.createElement(ConsentInfo, null));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.newCustomer.NewCustomer = NewCustomer;

 })(window);